import Mock from '@/mocks/Mock'
import InitData, { InitDataAttributes } from '@/models/InitData'

export default class InitDataMock extends Mock<InitDataAttributes> {
  constructor() {
    super('initData')
  }

  get() {
    return new InitData(this.data)
  }
}
